import React from 'react';
import { Autocomplete, TextField, createFilterOptions, Box, Typography } from '@mui/material';

const filter = createFilterOptions();

const CustomerAutocomplete = ({
    customers,
    selectedCustomer,
    handleCustomerChange,
    customerInputValue,
    setCustomerInputValue,
    isEditing,
    telefon,
    setTelefon
}) => {
    return (
        <>
            <Autocomplete
                freeSolo
                options={customers}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') return option;
                    if (option.inputValue) return option.inputValue;
                    return `${option.adSoyad} - ${option.telefon}`;
                }}
                value={selectedCustomer}
                onChange={handleCustomerChange}
                inputValue={customerInputValue}
                onInputChange={(event, newInputValue) => setCustomerInputValue(newInputValue)}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    const isExisting = options.some((option) =>
                        option.adSoyad.toLowerCase() === inputValue.toLowerCase()
                    );
                    if (inputValue !== '' && !isExisting) {
                        filtered.push({
                            inputValue,
                            adSoyad: `"${inputValue}" - Yeni müşteri olarak ekle`
                        });
                    }
                    return filtered;
                }}
                renderOption={(props, option) => {
                    const { key, ...otherProps } = props;
                    return (
                        <li key={option.id || key} {...otherProps}>
                            <Box>
                                <Typography variant="body1">{option.adSoyad}</Typography>
                                <Typography variant="caption" color="textSecondary">
                                    {option.telefon}
                                </Typography>
                            </Box>
                        </li>
                    );
                }}
                renderInput={(params) => <TextField {...params} label="Müşteri Adı Soyadı" required />}
                disabled={isEditing}
            />

            {!selectedCustomer && customerInputValue && !isEditing && (
                <Box sx={{ p: 2, border: '1px solid #ddd', borderRadius: 1, display: 'flex', flexDirection: 'column', gap: 2, bgcolor: 'action.hover' }}>
                    <Typography variant="subtitle2" color="primary">Yeni Müşteri Bilgileri</Typography>
                    <TextField
                        label="Telefon Numarası"
                        value={telefon}
                        onChange={(e) => setTelefon(e.target.value)}
                        fullWidth
                    />
                </Box>
            )}
        </>
    );
};

export default CustomerAutocomplete;
